import React from 'react';
export const UpArrow = () => {
    return (React.createElement("svg", { display: "block", enableBackground: "0 0 24 24", fill: "none", role: "img", transform: "scale(1,-1)", viewBox: "0 0 24 24", width: "24", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("title", null, "Up Arrow"),
        React.createElement("path", { d: "M18 9L12 15L6 9", stroke: "black", strokeLinecap: "square" })));
};
